import { FC } from 'react';
import { useTranslations } from 'next-intl';
import { Mail, Phone, Smartphone } from 'lucide-react';
import styles from './Contact.module.scss';
export const Contact: FC = () => {
  const t = useTranslations();
  return <section className={styles.section} data-sentry-component="Contact" data-sentry-source-file="Contact.tsx">
            <div className={styles.container}>

                {/* ── Header ── */}
                <div className={styles.header}>
                    <h1 className={styles.title}>{t('ourOffice')}</h1>
                    <p className={styles.desc}>{t('ourOfficeDesc')}</p>
                </div>

                {/* ── Body ── */}
                <div className={styles.body}>

                    {/* Left – photo */}
                    <div className={styles.imageWrap}>
                        <img src="https://hotdesk-assets.s3.eu-west-1.amazonaws.com/landing_pages/main_landing/images/contactUs.webp" alt="Our Office" className={styles.image} loading="lazy" />
                    </div>

                    {/* Right – contact cards */}
                    <div className={styles.cards}>

                        {/* Phone */}
                        <div className={styles.card}>
                            <div className={styles.iconBox}>
                                <Phone size={22} strokeWidth={1.8} data-sentry-element="Phone" data-sentry-source-file="Contact.tsx" />
                            </div>
                            <div className={styles.cardBody}>
                                <h4 className={styles.cardTitle}>{t('callUs')}</h4>
                                <p className={styles.cardValue} dir="ltr">
                                    {t('contactPhone')}
                                </p>
                                <p className={styles.cardMeta}>
                                    {t('contactHours')}
                                </p>
                            </div>
                        </div>

                        {/* Email */}
                        <div className={styles.card}>
                            <div className={styles.iconBox}>
                                <Mail size={22} strokeWidth={1.8} data-sentry-element="Mail" data-sentry-source-file="Contact.tsx" />
                            </div>
                            <div className={styles.cardBody}>
                                <h4 className={styles.cardTitle}>{t('emailUs')}</h4>
                                <a href={`mailto:${t('contactEmail1')}`} className={styles.cardValue}>
                                    {t('contactEmail1')}
                                </a>
                                <a href={`mailto:${t('contactEmail2')}`} className={styles.cardValue}>
                                    {t('contactEmail2')}
                                </a>
                            </div>
                        </div>

                        {/* Get App */}
                        <div className={styles.card}>
                            <div className={styles.iconBox}>
                                <Smartphone size={22} strokeWidth={1.8} data-sentry-element="Smartphone" data-sentry-source-file="Contact.tsx" />
                            </div>
                            <div className={styles.cardBody}>
                                <h4 className={styles.cardTitle}>{t('getApp')}</h4>
                                <div className={styles.appRow}>
                                    <a href="https://apps.apple.com/us/app/hotdesk/id1484609853" target="_blank" rel="noreferrer" className={styles.appBtn}>
                                        <img src="assets/icons/appleContact.svg" alt="App Store" className={styles.appBtnImg} loading="lazy" />
                                    </a>
                                    <a href="https://play.google.com/store/apps/details?id=io.hotdesk.app" target="_blank" rel="noreferrer" className={styles.appBtn}>
                                        <img src="/assets/icons/googleContact.svg" alt="Google Play" className={styles.appBtnImg} loading="lazy" />
                                    </a>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>;
};
export default Contact;